function addCSSVal(originalValue, valueToAdd) {
  // Parse a CSS value and return {number, unit}
  function parseValue(value) {
    const match = value.toString().match(/^(-?\d*\.?\d+)(.*)$/);
    if (!match) {
      throw new Error(`Invalid CSS value: ${value}`);
    }
    return {
      number: parseFloat(match[1]),
      unit: match[2] || ''
    };
  }

  try {
    if (originalValue === undefined) {
      return false;
    }
    const original = parseValue(originalValue);
    const toAdd = parseValue(valueToAdd);

    // Check if units match (or one is unitless)
    if (original.unit !== toAdd.unit && original.unit !== '' && toAdd.unit !== '') {
      throw new Error(`Cannot add different units: ${original.unit} and ${toAdd.unit}`);
    }

    // Use the unit from the original value, or from the value to add if original is unitless
    const resultUnit = original.unit || toAdd.unit;
    const resultNumber = original.number + toAdd.number;

    return resultNumber + resultUnit;
  } catch (error) {
    console.error('Error in addCSSVal:', error.message);
    return originalValue; // Return original value on error
  }
}
function adjustOwlStagePosition(e, carouselElement) {
    var $this = jQuery(carouselElement || this);
    var $stage = $this.find('.owl-stage');
    var stagePaddingVal = $stage.css("padding-left");
    stagePaddingVal = addCSSVal(stagePaddingVal, '-20px');
    
    var current = e.item.index + 1;
    var total = e.item.count;
    
    if (current === total) {
        $stage.css('left', `${stagePaddingVal}`);
    } else if (current === 1) {
        $stage.css('left', `-${stagePaddingVal}`);
    } else {
        $stage.css('left', '0');
    }
}
function getDeviceInfo() {
  const ua = navigator.userAgent;
  const info = {};

  // Device detection
  if (/iPad/.test(ua)) {
    info.device = "iPad";
  } else if (/iPhone/.test(ua)) {
    info.device = "iPhone";
  } else if (/iPod/.test(ua)) {
    info.device = "iPod";
  } else if (/Android/.test(ua)) {
    info.device = "Android Device";
  } else if (/Windows Phone/.test(ua)) {
    info.device = "Windows Phone";
  } else {
    info.device = "Desktop/Other";
  }

  // iOS version detection
  const iosMatch = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (iosMatch) {
    const major = iosMatch[1];
    const minor = iosMatch[2];
    const patch = iosMatch[3] || "0";
    info.iosVersion = `iOS ${major}.${minor}.${patch}`;
  } else {
    info.iosVersion = "Not iOS";
  }

  // TikTok in-app browser detection
  const isTikTok = /musical_ly|tiktok|bytedance/i.test(ua);
  info.isTikTokBrowser = isTikTok;

  // Additional browser info
  if (/Safari/.test(ua) && !/Chrome/.test(ua)) {
    info.browser = "Safari";
  } else if (/Chrome/.test(ua)) {
    info.browser = "Chrome";
  } else if (/Firefox/.test(ua)) {
    info.browser = "Firefox";
  } else if (/Edge/.test(ua)) {
    info.browser = "Edge";
  } else {
    info.browser = "Other/Unknown";
  }

  // Screen info
  info.screenWidth = screen.width;
  info.screenHeight = screen.height;
  info.devicePixelRatio = window.devicePixelRatio || 1;

  // Viewport info
  info.viewportWidth = window.innerWidth;
  info.viewportHeight = window.innerHeight;

  // Touch support
  info.touchSupport = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  return info;
}
function stop_bg_videos() {
  var $videos = jQuery("video[data-alt-poster]");
  
  $videos.each(function() {
    var $video = jQuery(this);
    
    // Handle poster attribute if data-alt-poster exists
    if ($video.attr("data-alt-poster") !== undefined) {
      $video.attr("poster", $video.attr("data-alt-poster"));
    }
    
    // Remove autoplay attribute
    $video.removeAttr("autoplay");
    
    // Get the DOM element and pause/reset it
    var video_el = this;
    video_el.pause();
    video_el.removeAttribute("src"); // empty source
    video_el.load();
  });
}
function stop_bg_videos_conditional() {
  if (should_stop_bg_vids) {
    stop_bg_videos();
  }
}
function pass_img_dataSrc_to_src(){
    $dynamicImages = jQuery("[data-src]");
    $dynamicImages.each(function(index) {
        var $this = jQuery(this);
        if ($this.css('display') !== 'none' && $this.is(':visible')) {
            this.src = $this.data('src');
        }
    });
}

// Track if Owl Carousel was dragged
let owlWasDragged = false;

// Your image click handler
function handleImageClick(imageUrl) {
  console.log('handleImageClick')
  // Only trigger modal if Owl Carousel wasn't dragged
  if (!owlWasDragged) {
    console.log('handleImageClick2')
    lity(imageUrl);
  }
}
function normalizeHeights(selector, device = 'both', the_option = 'tallest') {
  var $elements = jQuery(selector);
  
  // Check if we should apply based on device setting
  var windowWidth = jQuery(window).width();
  var isMobile = windowWidth <= 768; // Adjust breakpoint as needed
  
  $elements.css("height", "auto");

  if (device === 'mobile' && !isMobile) return;
  if (device === 'desktop' && isMobile) return;
  // If device === 'both', continue with normalization  
  
  var maxHeight = 0;
  var oppHeight = 2000;
  $elements.each(function() {
    if (the_option == 'tallest') {
      var height = jQuery(this).outerHeight();
      if (height > maxHeight) {
        maxHeight = height;
      }
    } else {
      height = jQuery(this).height();
      if (height < oppHeight) {
        oppHeight = height;
      }
    }
  });
  oppHeight = oppHeight < 300 ? 300 : oppHeight;
  var final_val = the_option == 'tallest' ? maxHeight : oppHeight;
  $elements.css("height", final_val + "px");
  if (the_option == 'shortest') {
    $elements.css("object-fit", "contain");
    // $elements.each(function() {
    //     var $el = $(this);
    //   // Temporarily remove width to get natural width
    //     var currentWidth = $el.css('width');
    //     $el.css('width', 'auto');
    //     var naturalWidth = $el.width();
    //     $el.css('width', naturalWidth + "px");
    // });
  }
}
function normalizeWidths(selector, device = 'both') {
  var $elements = jQuery(selector);
  
  // Check if we should apply based on device setting
  var windowWidth = jQuery(window).width();
  var isMobile = windowWidth <= 768; // Adjust breakpoint as needed
  
  $elements.css("width", "fit-content");

  if (device === 'mobile' && !isMobile) return;
  if (device === 'desktop' && isMobile) return;
  // If device === 'both', continue with normalization  
  
  var maxWidth = 0;
  $elements.each(function() {
    var width = jQuery(this).outerWidth();
    if (width > maxWidth) {
      maxWidth = width;
    }
  });
  
  $elements.css("width", maxWidth + "px");
}

// ===== start ANNOUNCEMENT TICKER BUILDER =====

// ===== TIMER MANAGEMENT FUNCTIONS =====

// Global timer intervals storage
const timerIntervals = {};

// Function to format time remaining
function formatTimeRemaining(milliseconds) {
  if (milliseconds <= 0) return null;

  const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
  const hours = Math.floor((milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);

  const paddedSeconds = seconds.toString().padStart(2, "0");

  return `${days}d ${hours}h ${minutes}m ${paddedSeconds}s`;
}

// Function to parse Singapore time string and convert to Date object
function parseSingaporeTime(timeString) {
  // Expected format: "YYYY-MM-DD HH:MM:SS" in Singapore time
  
  try {
    // Method 1: Try ISO format first (most reliable cross-browser)
    const parts = timeString.split(' ');
    if (parts.length === 2) {
      const datePart = parts[0];
      const timePart = parts[1];
      
      // Convert to ISO format with Singapore timezone offset
      const isoString = `${datePart}T${timePart}+08:00`;
      const date = new Date(isoString);
      
      if (!isNaN(date.getTime())) {
        return date;
      }
    }
    
    // Method 2: Manual parsing for better Safari compatibility
    const dateTimeRegex = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/;
    const match = timeString.match(dateTimeRegex);
    
    if (match) {
      const [, year, month, day, hour, minute, second] = match;
      
      // Create date in UTC and then adjust for Singapore timezone (+8 hours)
      const utcDate = new Date(Date.UTC(
        parseInt(year, 10),
        parseInt(month, 10) - 1, // Month is 0-indexed
        parseInt(day, 10),
        parseInt(hour, 10),
        parseInt(minute, 10),
        parseInt(second, 10)
      ));
      
      // Subtract 8 hours to convert from Singapore time to UTC, then let browser handle local display
      const singaporeDate = new Date(utcDate.getTime() - (8 * 60 * 60 * 1000));
      
      // Actually, we want to treat the input as Singapore time, so we add the offset
      const correctedDate = new Date(utcDate.getTime());
      
      return correctedDate;
    }
    
    // Method 3: Fallback to basic parsing
    const fallbackDate = new Date(timeString);
    if (!isNaN(fallbackDate.getTime())) {
      return fallbackDate;
    }
    
    throw new Error('Unable to parse date');
    
  } catch (error) {
    console.error(`Error parsing Singapore time "${timeString}":`, error);
    // Return a date in the past to make it expired
    return new Date(0);
  }
}

// Function to check if a timer has expired
function isTimerExpired(endTimeStr) {
  if (!endTimeStr) return false;
  
  try {
    const endTime = parseSingaporeTime(endTimeStr);
    const now = new Date();
    return endTime.getTime() <= now.getTime();
  } catch (error) {
    console.warn(`Invalid time format: ${endTimeStr}`);
    return true; // Treat invalid times as expired
  }
}

// Function to check if an announcement block has any expired timers
function hasExpiredTimers(blockData) {
  if (blockData.type === 'timer') {
    return isTimerExpired(blockData.endTime);
  }
  
  // Check for nested timers in announcement blocks
  if (blockData.timers && Array.isArray(blockData.timers)) {
    return blockData.timers.some(timer => isTimerExpired(timer.endTime));
  }
  
  // Check for single nested timer
  if (blockData.timer && blockData.timer.endTime) {
    return isTimerExpired(blockData.timer.endTime);
  }
  
  return false;
}

// Function to filter out expired announcements
function filterExpiredAnnouncements(tickerData) {
  const filteredBlocks = {};
  
  Object.keys(tickerData).forEach(blockId => {
    const blockData = tickerData[blockId];
    
    if (!hasExpiredTimers(blockData)) {
      filteredBlocks[blockId] = blockData;
    } else {
      console.log(`Filtered out expired block: ${blockId}`);
    }
  });
  
  return filteredBlocks;
}

// Function to remove expired timer blocks and rebuild ticker
function removeExpiredBlocks(tickerId, expiredBlockIds, announcementMap) {
  if (!announcementMap[tickerId] || !announcementMap[tickerId].blocks) {
    return;
  }

  // Remove expired blocks from the announcement map
  expiredBlockIds.forEach(blockId => {
    delete announcementMap[tickerId].blocks[blockId];
    console.log(`Removed expired block: ${blockId} from ticker: ${tickerId}`);
  });

  // Check if there are any blocks left
  const remainingBlocks = Object.keys(announcementMap[tickerId].blocks || {});
  if (remainingBlocks.length === 0) {
    // If no blocks remain, hide the entire ticker
    jQuery(`#${tickerId}`).fadeOut();
    console.log(`All blocks expired, hiding ticker: ${tickerId}`);
    return;
  }

  // Rebuild the ticker with remaining blocks
  buildAnnouncementTicker(tickerId, announcementMap);
  console.log(`Rebuilt ticker ${tickerId} after removing expired blocks`);
}

// Function to start countdown timer for specific timer elements
function startCountdownTimer(tickerId, timerElements, announcementMap) {
  // Clear existing timer if any
  if (timerIntervals[tickerId]) {
    clearInterval(timerIntervals[tickerId]);
  }

  timerIntervals[tickerId] = setInterval(function() {
    const expiredBlockIds = [];

    // Update specific timer elements
    timerElements.each(function() {
      const timerElement = jQuery(this);
      const endTimeStr = timerElement.attr('data-timer-target');
      const blockElement = timerElement.closest('[data-block-id]');
      const blockId = blockElement.attr('data-block-id');

      if (!endTimeStr || !blockId) return;

      try {
        const endTime = parseSingaporeTime(endTimeStr);
        const now = new Date();
        const timeRemaining = endTime.getTime() - now.getTime();

        if (timeRemaining <= 0) {
          // Mark this block as expired (the entire announcement block containing the timer)
          if (!expiredBlockIds.includes(blockId)) {
            expiredBlockIds.push(blockId);
          }
          timerElement.text('Expired');
        } else {
          const formattedTime = formatTimeRemaining(timeRemaining);
          timerElement.text(formattedTime);
        }
      } catch (error) {
        console.warn(`Invalid time format for timer: ${endTimeStr}`);
        timerElement.text('Invalid time');
      }
    });

    // Remove expired blocks if any
    if (expiredBlockIds.length > 0) {
      // Stop the current timer
      clearInterval(timerIntervals[tickerId]);
      delete timerIntervals[tickerId];
      
      // Remove expired blocks and rebuild
      removeExpiredBlocks(tickerId, expiredBlockIds, announcementMap);
    }
  }, 1000);
}

// Function to stop countdown timer
function stopCountdownTimer(tickerId) {
  if (timerIntervals[tickerId]) {
    clearInterval(timerIntervals[tickerId]);
    delete timerIntervals[tickerId];
  }
}

// Function to create a single announcement block (can contain nested timers)
function _createAnnouncementBlock(data, blockId) {
  const block = jQuery('<div></div>')
  .addClass('announcement__block announcement__block--text announcement__ticker')
  .attr('data-slide', blockId)
  .attr('data-slide-index', blockId)
  .attr('data-block-id', blockId);

  const textBreak = jQuery('<span></span>')
  .addClass('text-highlight__break')
  .css('color', data.textColor || '#000000');

  // Add main text
  let textContent = data.text || '';

  // Add nested timer if present
  if (data.timer && data.timer.endTime) {
    const timerSpan = jQuery('<span></span>')
    .addClass('top_notice_timer')
    .attr('data-timer-target', data.timer.endTime)
    .css('color', data.timer.highlightColor || data.highlightColor || '#d43747')
    .text('Loading...');

    const timerLabel = data.timer.label || 'Ends in:';
    textContent += `\u2003+ + +\u2003 <b>${timerLabel}</b> `;
    textBreak.html(textContent);
    textBreak.append(timerSpan);
    textContent = '';
  }

  // Add multiple nested timers if present
  if (data.timers && Array.isArray(data.timers)) {
    data.timers.forEach((timer, index) => {
      const timerSpan = jQuery('<span></span>')
      .addClass('top_notice_timer')
      .attr('data-timer-target', timer.endTime)
      .css('color', timer.highlightColor || data.highlightColor || '#d43747')
      .text('Loading...');

      const timerLabel = timer.label || 'Ends in:';
      textContent += ` <b>${timerLabel}</b> `;
      textBreak.html(textContent);
      textBreak.append(timerSpan);
      textContent = '';
    });
  }

  // Add link if provided
  if (data.link && data.linkText) {
    const linkElement = jQuery('<a></a>')
    .attr('href', data.link)
    .attr('title', data.linkText)
    .css({
      'color': data.highlightColor || '#d43747',
      'text-decoration': 'none',
      'border-bottom': '1px solid'
    })
    .html(`<b>${data.linkText}</b>`);

    // Set target if newWindow is true
    if (data.newWindow) {
      linkElement.attr('target', '_blank');
    }

    textContent += ' ';
    textBreak.html(textBreak.html() + textContent);
    textBreak.append(linkElement);
    textBreak.append('\u2003+ + +\u2003');
  } else if (textContent) {
    textBreak.html(textBreak.html() + textContent);
  }

  block.append(textBreak);
  return block;
}

// Function to create a standalone timer block (legacy support)
function _createTimerBlock(data, blockId) {
  const block = jQuery('<div></div>')
  .addClass('announcement__block announcement__ticker')
  .attr('data-slide', blockId)
  .attr('data-slide-index', blockId)
  .attr('data-block-id', blockId);

  const timerDiv = jQuery('<div></div>')
  .addClass('noti-bar__timer');

  const labelElement = jQuery('<b></b>')
  .text(data.label || 'Sale ends in:')
  .css('color', data.textColor || '#000000');

  const timerSpan = jQuery('<span></span>')
  .addClass('top_notice_timer')
  .attr('data-timer-target', data.endTime || '')
  .css('color', data.highlightColor || '#d43747')
  .text('Loading...');

  timerDiv.append(labelElement).append("\u00A0").append(timerSpan);
  block.append(timerDiv);

  return block;
}

// Function to create the ticker content with consistent speed
function _createSeamlessTickerContent(tickerData, settings) {
  // Create the content once
  const contentBlocks = [];

  // Process all blocks in the ticker data
  jQuery.each(tickerData, function(blockId, blockData) {
    let blockElement;

    if (blockData.type === 'timer') {
      blockElement = _createTimerBlock(blockData, blockId);
    } else {
      // Default to announcement block (can contain nested timers)
      blockElement = _createAnnouncementBlock(blockData, blockId);
    }

    contentBlocks.push(blockElement);
  });

  // Create container for seamless looping
  const tickerContainer = jQuery('<div></div>')
  .addClass('announcement__text ticker-rtl ticker--animated')
  .attr('data-ticker-text', '')
  .css('animation-play-state', 'running');

  // Calculate minimum content width for consistent speed
  const minContentWidth = settings.minContentWidth || 1200; // Minimum pixels for consistent speed
  
  // Add content with separators
  let currentCopy = 0;
  const maxCopies = 10; // Prevent infinite loops
  
  while (currentCopy < maxCopies) {
    let addedInThisCopy = false;
    
    jQuery.each(contentBlocks, function(index, block) {
      tickerContainer.append(block.clone());
      tickerContainer.append(block.clone());
      addedInThisCopy = true;

      // Add separator after each block
      const separator = jQuery('<span></span>')
      .addClass('announcement__separator')
      .html('');
      tickerContainer.append(separator);
    });
    
    if (!addedInThisCopy) break; // No content blocks to add
    
    currentCopy++;
    
    // Check if we have enough content width
    // We'll do this check after building to ensure consistent behavior
    if (currentCopy >= 2) { // Always have at least 2 copies
      break;
    }
  }

  return tickerContainer;
}

// Function to calculate optimal animation duration with consistent speed
function _calculateAnimationDuration(contentElement, baseSpeed = 50) {
  // Temporarily add to DOM to measure
  const tempContainer = jQuery('<div></div>')
  .css({
    'position': 'absolute',
    'visibility': 'hidden',
    'white-space': 'nowrap'
  })
  .append(contentElement.clone());

  jQuery('body').append(tempContainer);
  const contentWidth = tempContainer.width();
  tempContainer.remove();

  // For consistent speed, we use the full content width
  // This ensures the speed remains consistent regardless of content amount
  const duration = contentWidth / baseSpeed;

  return Math.max(duration, 8); // Minimum 8 seconds
}

// Function to build the complete announcement ticker structure
function buildAnnouncementTicker(tickerId, announcementMap) {
  const targetElement = jQuery('#' + tickerId);

  if (!targetElement.length) {
    console.warn(`Target element with ID '${tickerId}' not found`);
    return false;
  }

  if (!announcementMap.hasOwnProperty(tickerId)) {
    console.warn(`No ticker data found for ID '${tickerId}'`);
    return false;
  }

  // Clear existing content and stop timers
  stopCountdownTimer(tickerId);
  targetElement.empty();

  // Get ticker data and settings
  const tickerData = announcementMap[tickerId];
  const settings = tickerData.settings || {};

  // Filter out expired announcements before building
  const activeBlocks = filterExpiredAnnouncements(tickerData.blocks || {});

  // Check if there are any active blocks to display
  if (Object.keys(activeBlocks).length === 0) {
    console.log(`No active blocks to display for ticker: ${tickerId}`);
    targetElement.hide();
    return false;
  }
  console.log(activeBlocks)

  // Update the announcement map with filtered blocks
  announcementMap[tickerId].blocks = activeBlocks;

  // Create the main structure
  const announcementBarStatic = jQuery('<div></div>')
  .addClass('announcement-bar-static');

  const announcement = jQuery('<div></div>')
  .addClass('announcement font-body')
  .attr('data-announcement', '');

  const announcementSlider = jQuery('<div></div>')
  .addClass('announcement__slider');

  const announcementSlide = jQuery('<div></div>')
  .addClass('announcement__slide')
  .attr('data-announcement-slide', '');

  const tickerFrame = jQuery('<div></div>')
  .addClass('announcement__message')
  .attr('data-ticker-frame', '')
  .attr('data-marquee-speed', settings.speed || '100');

  const announcementScale = jQuery('<div></div>')
  .addClass('announcement__scale')
  .attr('data-ticker-scale', '');

  // Create seamless ticker content with consistent speed
  const tickerContent = _createSeamlessTickerContent(activeBlocks, settings);

  // Calculate optimal animation duration for consistent speed
  const animationDuration = settings.animationTime || _calculateAnimationDuration(tickerContent, settings.speed || 50);
  tickerContent.css('animation-duration', animationDuration + 's');

  announcementScale.append(tickerContent);

  // Assemble the structure
  tickerFrame.append(announcementScale);
  announcementSlide.append(tickerFrame);
  announcementSlider.append(announcementSlide);
  announcement.append(announcementSlider);
  announcementBarStatic.append(announcement);
  targetElement.append(announcementBarStatic);

  // Show the ticker in case it was hidden
  targetElement.show();

  // Start countdown timer if ticker has timer blocks
  const timerElements = targetElement.find('.top_notice_timer[data-timer-target]');
  if (timerElements.length > 0) {
    startCountdownTimer(tickerId, timerElements, announcementMap);
  }

  console.log(`Built announcement ticker for: ${tickerId} with ${Object.keys(activeBlocks).length} active blocks`);
  return true;
}

// Function to build all announcement tickers found in the DOM
function buildAllAnnouncementTickers(announcementMap) {
  jQuery.each(announcementMap, function(tickerId, tickerData) {
    buildAnnouncementTicker(tickerId, announcementMap);
  });
}

// Function to update a single ticker after it's been built
function updateAnnouncementTicker(tickerId, newData, announcementMap) {
  // Stop existing timer
  stopCountdownTimer(tickerId);

  // Update the data in the map
  if (announcementMap[tickerId]) {
    jQuery.extend(true, announcementMap[tickerId], newData);

    // Rebuild the ticker with new data
    buildAnnouncementTicker(tickerId, announcementMap);
    console.log(`Updated announcement ticker: ${tickerId}`);
    return true;
  }

  console.warn(`Could not update announcement ticker: ${tickerId}`);
  return false;
}

function getNextResetTime(resetTimes = ['00:00', '12:00']) {
  const now = new Date();
  const currentDate = now.toISOString().split('T')[0]; // Get YYYY-MM-DD
  const currentTimeMinutes = now.getHours() * 60 + now.getMinutes();
  
  // Convert reset times to minutes and sort them
  const resetMinutes = resetTimes
    .map(time => {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    })
    .sort((a, b) => a - b);
  
  // Find the next reset time today
  let nextResetMinutes = resetMinutes.find(resetTime => resetTime > currentTimeMinutes);
  
  let targetDate = currentDate;
  
  // If no reset time found today, use the first reset time tomorrow
  if (!nextResetMinutes) {
    nextResetMinutes = resetMinutes[0];
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    targetDate = tomorrow.toISOString().split('T')[0];
  }
  
  // Convert minutes back to hours and minutes
  const hours = Math.floor(nextResetMinutes / 60);
  const minutes = nextResetMinutes % 60;
  
  // Format as HH:MM:SS
  const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
  
  return `${targetDate} ${timeString}`;
}
function getNextResetTime(resetTimes = ['00:00', '12:00']) {
  // Get current time in Singapore timezone (UTC+8)
  const now = new Date();
  const singaporeTime = new Date(now.toLocaleString("en-US", {timeZone: "Asia/Singapore"}));
  
  const currentDate = singaporeTime.toISOString().split('T')[0]; // Get YYYY-MM-DD in Singapore time
  const currentTimeMinutes = singaporeTime.getHours() * 60 + singaporeTime.getMinutes();
  
  // Convert reset times to minutes and sort them
  const resetMinutes = resetTimes
    .map(time => {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    })
    .sort((a, b) => a - b);
  
  // Find the next reset time today
  let nextResetMinutes = resetMinutes.find(resetTime => resetTime > currentTimeMinutes);
  
  let targetDate = currentDate;
  
  // If no reset time found today, use the first reset time tomorrow
  if (!nextResetMinutes) {
    nextResetMinutes = resetMinutes[0];
    const tomorrow = new Date(singaporeTime);
    tomorrow.setDate(tomorrow.getDate() + 1);
    targetDate = tomorrow.toISOString().split('T')[0];
  }
  
  // Convert minutes back to hours and minutes
  const hours = Math.floor(nextResetMinutes / 60);
  const minutes = nextResetMinutes % 60;
  
  // Format as HH:MM:SS
  const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
  
  return `${targetDate} ${timeString}`;
}
// ===== end ANNOUNCEMENT TICKER BUILDER =====

